import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const EventPage = lazy (() => import ('@/pages/event/EventPage.tsx'))
const EventContentAddPage = lazy(() =>  import  ('@/pages/event/EventContentAddPage'))
const EventAddPage = lazy(() => import ('@/pages/event/EventAddPage.tsx'))
const EventContentDetailPage = lazy(()=> import ('@/pages/event/EventContentDetailPage'))
const EventDetailPage = lazy(()=> import ('@/pages/event/EventDetailPage.tsx'))

/**
 * 이벤트 관리 라우트
 * - 이벤트
 *
 */
export const eventRoutes: RouteWithMeta = {
  path: 'event',
  meta: {
    label: '이벤트',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 이벤트 =====
    {
      path: '',
      element: withSuspense(<EventPage/>),
      meta: {
        label: '이벤트목록',
        showInMenu: true,
      }
    },
    {
      path: 'contentAdd',
      element: withSuspense(<EventContentAddPage/>),
      meta: {
        label: '이벤트 등록',
        showInMenu: false,
      }
    },
    {
      path: 'add',
      element: withSuspense(<EventAddPage/>),
      meta: {
        label: '이벤트 등록',
        showInMenu: false
      }
    },
    {
      path: 'content/:id',
      element: withSuspense(<EventContentDetailPage/>),
      meta: {
        label: '이벤트 상세',
        showInMenu: false,
      }
    },
    {
      path: 'normal/:id',
      element: withSuspense(<EventDetailPage/>),
      meta: {
        label: '이벤트 상세',
        showInMenu: false
      }
    },
  ]
}